import jQuery from 'jquery';
let $ = jQuery;
import gap from 'MOBILE/Gap.js';

import "./Widget.js";

// define EVENTs
import "./AddToBag.js";
    
/**
    * class HSN.Widget.ApplePay
    *
    * Encapsulates the common functionality of the ApplePay Widget.
    **/
HSN.Widget.ApplePay = function () {
    var application;
    var container;
    var commerceService;
    var deviceInformation;
    var eventIdentity;
    var basketIdentity;
    var applePaySupported;
    var applePayType = HSN.Widget.ApplePay.TYPE.NONE;
    var merchantIdentifier = 'merchant.com.hsn.applepay';
    var applePayError = 'Unfortunately, we cannot process your Apple Pay order at this time. Please try again or call customer service at 1.877.916.0354.';
    var proxyButtonDelay = 500;
    var applePaySession;
    /**
        * new HSN.Widget.ApplePay.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.ApplePay]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        deviceInformation = application.DeviceInformation;
        eventIdentity = config.eventIdentity || '';
        commerceService = application._getCommerceService();
        determineSupport();
        bindEvents();
    }

    function setupApplePaySession(initialProductPrice) {
        var applePayRequest = {
            countryCode: 'US',
            currencyCode: 'USD',
            supportedNetworks: ['visa', 'masterCard', 'discover', 'amex'],
            merchantCapabilities: ['supports3DS'],
            requiredShippingContactFields: ['postalAddress', 'name', 'email', 'phone'],
            requiredBillingContactFields: ['postalAddress', 'name'],
            total: { label: 'Total', amount: initialProductPrice }
        }

        var session = new window.ApplePaySession(1, applePayRequest);
        HSN.Instance().SetApplePaySession(session);
    }

    function determineSupport() {
        if (deviceInformation.IsNativeApp) {
            //Does native app support apple pay?
            HSN.OnAccountStatusLoad(function(data) {
                if (data.applePaySupported) {
                    applePayType = HSN.Widget.ApplePay.TYPE.NATIVE;
                }
                applePaySupported = data.applePaySupported;
                ToggleApplePay(data.applePaySupported);
            });
        }
        else {
            //TODO uncomment to force applepay button to show for testing UI
            //applePaySupported = true;
            //applePayType = HSN.Widget.ApplePay.TYPE.WEB;
            //window.setTimeout(function () {
            //    ToggleApplePay(applePaySupported);
            //}, proxyButtonDelay);
            //return;
            if (window.ApplePaySession) {
                //TODO: This seems to be a bug in apples sandbox checks, we need to bypass canMakePaymentsWithActiveCard, it will return false always in sandbox
                if (window.location.hostname === 'wwwlocal.hsn.com' || window.location.hostname === 'qa1.hsn.com') {
                    applePaySupported = true;
                    applePayType = HSN.Widget.ApplePay.TYPE.WEB;
                    ToggleApplePay(applePaySupported);
                    return;
                }
                var promise = window.ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
                promise.then(function (canMakePayments) {
                    if (canMakePayments) {
                        applePaySupported = true;
                        applePayType = HSN.Widget.ApplePay.TYPE.WEB;

                        //proxy buttons, have to delay here
                        window.setTimeout(function () {
                            ToggleApplePay(applePaySupported);
                        }, proxyButtonDelay);
                    }
                    else {
                        applePaySupported = false;
                    }
                });
            }
            else {
                applePaySupported = false;
                ToggleApplePay(applePaySupported);
            }
        }
    }

    function bindEvents() {
        //Allow external widgets to toggle button
        application.Events.On(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, function (toggle) {
            ToggleApplePay(toggle);
        });

        application.Events.On(HSN.Widget.AddToBag.EVENT.ADD_SUCCESS, function (addedBasketItemIdentity) {
            basketIdentity = addedBasketItemIdentity;
            OpenApplePay();
        });

        application.Events.On(HSN.Widget.ApplePay.EVENT.OPEN_PAYMENT_SHEET, function (sourceEventIdentity) {
            if (eventIdentity === sourceEventIdentity) {
                OpenApplePay();
            }
        });
            
        //window events for native app
        window.ApplePayComplete = HandleComplete;
        window.ApplePayError = HandleError;
        window.ApplePayCancelled = HandleCancel;
    }

    function HandleComplete(data) {
        application.Events.Trigger(HSN.Widget.ApplePay.EVENT.ADD_SUCCESS);
        HSN.SetTempWait(30000);
        commerceService.ProcessOrder({ debitAuthorized : false, debitAuthorizationRequired : false, sessionIdentity: '' }, {
            callback: function (data) {
                if (data.success) {
                    Navigate('/checkout/order-confirmation?orderId=' + data.orderNumber);
                }
                else {
                    HandleError(applePayError);
                }
            }
        });
    }

    function HandleCancel() {
        if (basketIdentity) {
            HSN.SetWait();
            commerceService.RemoveBagItem({ bagItemId: basketIdentity }, {
                callback: function () {
                    HSN.RemoveWait();
                }
            });
        }
    }

    function HandleError(message) {
        if(!message || message === '(null)') {
            message = applePayError;
        }
        message = encodeURIComponent(message);
        application.Events.Trigger(HSN.Widget.ApplePay.EVENT.ADD_ERROR);
        Navigate('/checkout/ordererror?errorMessage=' + message);
    }

    function ToggleApplePay(toggle) {
        if (applePaySupported) {
            $('.apple-pay-button').toggle(toggle);
            $('.buy-selector .express-buy-proxy').toggle(!toggle);
            $('.add-to-bag-buttons .express-buy').toggle(!toggle);
            $('.button-group .express-buy').toggle(!toggle);
            $('.apple-pay-container').toggle(toggle)
            if (toggle) {
                $('.paypal-container').addClass('half');
            } 
            else {
                $('.paypal-container').removeClass('half');
            }
        }
        else {
            $('.apple-pay-button').toggle(false);
            $('.buy-selector .express-buy-proxy').toggle(true);
            $('.add-to-bag-buttons .express-buy').toggle(true);
            $('.button-group .express-buy').toggle(true);
            $('.paypal-container').removeClass('half');
            $('.apple-pay-container').toggle(false)
        }
    }

    function Navigate(url) {
        if (deviceInformation.IsNativeApp) {
            url = gap.FullyQualifyRelativeLink(url);
            var encodedUrl = encodeURIComponent(url);
            var command;
            if (deviceInformation.IsTablet) {
                if (deviceInformation.OsName === 'Android') {
                    command = 'hsn://HSNWebView.PopOverWithUrl/' + encodedUrl + '/1';
                    gap.ExecCommand(command);
                }
                else {
                    command = 'hsn://HSNWebView.PushUrl/' + encodedUrl;
                    gap.ExecCommand(command);
                }
            }
            else {
                command = gap.BuildGapCommand(url);
                gap.ExecCommand(command);
            }
        }
        else {
            window.location.href = url;
        }
    }
        
    function Destroy() {
        application = container = commerceService = null;
    }
    function OpenApplePay() {
        if (applePayType === HSN.Widget.ApplePay.TYPE.NATIVE) {
            commerceService.ApplePayBagGet({}, {
                callback: function (data) {
                    OpenPaymentSheet(data);
                },
                errorCallback: function () {
                    alert('Unfortunately there was a problem with Apple Pay. Please try again or contact customer service.');
                }
            });
        }
        else {
            OpenPaymentSheet();
        }
    }
    function OpenPaymentSheet(lineItems) {
        if (applePayType === HSN.Widget.ApplePay.TYPE.NATIVE) {
            var jsonString = JSON.stringify(lineItems);
            var escapedGapData = escape(jsonString);
            gap.ExecCommand('hsn://HSNWebView.ApplePay//' + escapedGapData);
        }
        else {
            applePaySession = application.GetApplePaySession();
            applePaySession.oncancel = HandleCancel;
            applePaySession.onvalidatemerchant = HandleValidateMerchant;
            applePaySession.onshippingcontactselected = HandleShippingContactSelected;
            //Future use?
            //applePaySession.onpaymentmethodselected = PaymentMethodSelected;
            applePaySession.onpaymentauthorized = HandlePaymentAuthorized;
            applePaySession.begin();
        }
    }

    function HandleValidateMerchant(event) {
        commerceService.ApplePayValidate({ validationUrl: event.validationURL }, {
            callback: function (data) {
                if(data && data.signature) {
                    applePaySession.completeMerchantValidation(data);
                }
                else {
                    HandleCancel();
                    applePaySession.abort();
                }
            },
            errorCallback: function () {
                HandleCancel();
                applePaySession.abort();
            }
        });
    }
    function HandleShippingContactSelected(event) {
        var zipCode = event.shippingContact.postalCode;
        commerceService.ApplePayChangeShipping({ ZipCode : zipCode }, {
            callback: function (data) {
                var newTotal = data.LineItemData.Total;
                var newLineItems = data.LineItemData.LineItems;
                applePaySession.completeShippingContactSelection(applePaySession.STATUS_SUCCESS, [], newTotal, newLineItems);
            },
            errorCallback: function () {
                applePaySession.completeShippingContactSelection(applePaySession.STATUS_FAILURE, [], { label: 'Total', amount: .01 }, []);
            }
        });
    }
    //function HandlePaymentMethodSelected(event) {
    //    var zipCode = event.shippingContact.postalCode;
    //    commerceService.ApplePayChangePayment({ ZipCode: zipCode }, {
    //        callback: function (data) {
    //            var newTotal = data.LineItemData.Total;
    //            var newLineItems = data.LineItemData.LineItems;
    //            applePaySession.completePaymentMethodSelection(applePaySession.STATUS_SUCCESS, [], newTotal, newLineItems);
    //        },
    //        errorCallback: function () {
    //            applePaySession.completePaymentMethodSelection(applePaySession.STATUS_FAILURE, [], { label: 'Total', amount: .01 }, []);
    //        }
    //    });
    //}
    function HandlePaymentAuthorized(event) {
        var applePayment = event.payment;
        var validationStatus = validatePaymentObject(applePayment);
        if(validationStatus) {
            applePaySession.completePayment(validationStatus);
            return;
        }
        var billingAddress = getAddressObject(applePayment.billingContact);
        var shippingAddress = getAddressObject(applePayment.shippingContact);
        var email = applePayment.shippingContact.emailAddress;
        var cardDetails = {
            Network: applePayment.token.paymentMethod.network,
            PaymentName: applePayment.token.paymentMethod.displayName
        }
        var paymentData = applePayment.token.paymentData;
        commerceService.ApplePayComplete({ BillingAddress: billingAddress, ShippingAddress: shippingAddress, EmailAddress: email, CardDetails: cardDetails, PaymentData: paymentData }, {
            callback: function (data) {
                if(data.success) {
                    applePaySession.completePayment(applePaySession.STATUS_SUCCESS);
                    HandleComplete();
                }
                else {
                    var message = data.message;
                    applePaySession.completePayment(data.errorResponse.Code);

                    if(data.errorResponse && data.errorResponse.Code === 1) {
                        HandleError(message);
                    }
                }
            },
            errorCallback: function () {
                applePaySession.completePayment(applePaySession.STATUS_FAILURE);
            }
        });
    }
    function getAddressObject(appleContact) {
        var address = {
            FirstName: appleContact.givenName,
            LastName: appleContact.familyName,
            AddressLine1: appleContact.addressLines[0],
            AddressLine2: appleContact.addressLines[1],
            City: appleContact.locality,
            State: appleContact.administrativeArea,
            ZipCode: appleContact.postalCode
        }
        if("phoneNumber" in appleContact) {
            address.PhoneNumber = appleContact.phoneNumber;
        }
        return address;
    }
    function validatePaymentObject(applePayment) {
        if(!applePayment.billingContact || !applePayment.billingContact.givenName || !applePayment.billingContact.familyName || !applePayment.billingContact.addressLines || applePayment.billingContact.addressLines.length < 1 ||
            !applePayment.billingContact.addressLines[0] || !applePayment.billingContact.locality || !applePayment.billingContact.administrativeArea || !applePayment.billingContact.postalCode) {
            return applePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS;
        }
        if (!applePayment.shippingContact || !applePayment.shippingContact.givenName || !applePayment.shippingContact.familyName || !applePayment.shippingContact.addressLines || applePayment.shippingContact.addressLines.length < 1 ||
            !applePayment.shippingContact.addressLines[0] || !applePayment.shippingContact.locality || !applePayment.shippingContact.administrativeArea || !applePayment.shippingContact.postalCode) {
            return applePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS;
        }
        if(!applePayment.shippingContact.emailAddress || !applePayment.shippingContact.phoneNumber) {
            return applePaySession.STATUS_INVALID_SHIPPING_CONTACT;
        }
        return '';
    }
    function getApplePaySessionStatus(statusCode) {
        switch(statusCode) {
            case 1:
                return applePaySession.STATUS_FAILURE;
            case 2:
                return applePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS;
            case 3:
                return applePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS;
            case 4:
                return applePaySession.STATUS_INVALID_SHIPPING_CONTACT;
        }
    }
    return {
        init: init,
        setupApplePaySession: setupApplePaySession,
        Destroy: Destroy
    }
};

HSN.Widget.ApplePay.EVENT = {
    ADD_SUCCESS: 'HSN.Widget.ApplePay:ADD_SUCCESS',
    ADD_ERROR: 'HSN.Widget.ApplePay:ADD_ERROR',
    TOGGLE_APPLE_PAY: 'HSN.Widget.ApplePay:TOGGLE_APPLE_PAY',
    OPEN_PAYMENT_SHEET: 'HSN.Widget.ApplePay:OPEN_PAYMENT_SHEET'
};
HSN.Widget.ApplePay.TYPE = {
    NATIVE: 'HSN.Widget.ApplePay.Type:NATIVE',
    WEB: 'HSN.Widget.ApplePay.Type:WEB',
    NONE: 'HSN.Widget.ApplePay.Type:NONE'
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/ApplePay.js